import { Component } from '@angular/core';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';
import { Router } from '@angular/router';
import { convertToISO } from 'app/core/shared/helper/date.helper';
import { Wrsv } from 'app/modules/equipment-registration/model/wrsv.model';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';

@Component({
  selector: 'app-wrsv',
  templateUrl: './wrsv.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./wrsv.component.scss']
})
export class WrsvComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public wrsvForm: Wrsv = new Wrsv()
  public tempWrsvForm: Wrsv = new Wrsv()
  public wrsvTypleList: []
  public wellStringId: any
  public selectedWRSVType: any;  // Variable to hold the selected type object
  public isReplace: boolean = true;
  public isLockOpen: boolean = true
  public hasTrsssv: boolean = false

  constructor(
    private equipmentServices: EquipRegistrationServices,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.initializeWRSVForm()
    this.getTypeWrsvList()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (!wellEquipment) return;

      this.wellStringId = wellEquipment.wellStringId

      if (wellEquipment?.wrsv) {
        this.wrsvForm = new Wrsv(wellEquipment?.wrsv);
      } else {
        this.initializeWRSVForm()
      }

      if(wellEquipment?.scssv) {
        this.hasTrsssv = true
      }

      this.handleValueForm(wellEquipment)
      this.tempWrsvForm = new Wrsv(this.wrsvForm)
    })

    this.equipmentServices.isReplace$.subscribe(value => {
      this.isReplace = value;
    });
  }

  private initializeWRSVForm(): void {
    this.wrsvForm.reset()
  }

  private handleValueForm(wellEquipment) {

    if (!this.wrsvForm.scssvId) {
      this.wrsvForm.scssvId = wellEquipment.scssv?.id
    }

  }

  private getTypeWrsvList() {
    this.equipmentServices.getSssvType().subscribe(res => {
      this.wrsvTypleList = res
    })
  }

  disabledSave() {
    return !this.wrsvForm.scssvId || !this.wrsvForm.trsvType || !this.wrsvForm.initialInstalledDate || this.isFormChange()
  }

  private isFormChange() {
    return JSON.stringify(this.wrsvForm) === JSON.stringify(this.tempWrsvForm);
  }

  save() {
    const operation = this.isReplace ?
      this.equipmentServices.addWrsv(this.wrsvForm) :
      this.equipmentServices.updateWrsv(this.wrsvForm);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.wellStringId).subscribe();
      }
    });
  }
}
